"use client";

import { useEffect } from "react";
import { initHome } from "@/lib/motion/home";

/** Starts the homepage choreography (pinned chapters, canvas rails, parallax sheets). Renders nothing. */
export function HomeMotion() {
  useEffect(() => initHome(), []);
  return null;
}
